module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('shared-provide-variation', {
    attrs: {
      "variation": _vm.variation,
      "fromModule": _vm.fromModule,
      "toModule": _vm.toModule
    },
    on: {
      "change": _vm.emitToParent
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loadingVariationAttributes
    }
  }), _vm._v(" "), _vm._l((_vm.variationAttributes), function(attribute) {
    return _c('form-group', {
      key: attribute.id + '-' + (_vm.variation.sku || _vm.variation.id || ''),
      attrs: {
        "label": attribute.name,
        "columns": 6,
        "required": attribute.isRequired,
        "error": _vm.getError(String(attribute.id), _vm.variation.sku)
      }
    }, [(attribute.isMultipleSelection || attribute.isCustomizable) ? _c('multiselect', {
      key: 'ms-' + attribute.id + '-' + (_vm.variation.sku || _vm.variation.id || ''),
      attrs: {
        "options": attribute.values || [],
        "track-by": "id",
        "label": "name",
        "multiple": attribute.isMultipleSelection || attribute.isCustomizable,
        "close-on-select": !attribute.isMultipleSelection,
        "clear-on-select": false,
        "hide-selected": true,
        "taggable": attribute.isCustomizable,
        "placeholder": _vm.getVariationAttributePlaceholder(attribute),
        "disabled": _vm.disabledInputs()
      },
      on: {
        "tag": function (val) { return _vm.addCustomTag(attribute, val); }
      },
      model: {
        value: (_vm.localVarAttrs[attribute.id]),
        callback: function($$v) {
          _vm.$set(_vm.localVarAttrs, attribute.id, $$v)
        },
        expression: "localVarAttrs[attribute.id]"
      }
    }) : (attribute.values && attribute.values.length) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.localVarAttrs[attribute.id]),
        expression: "localVarAttrs[attribute.id]"
      }],
      key: 'ss-' + attribute.id + '-' + (_vm.variation.sku || _vm.variation.id || ''),
      staticClass: "form-select",
      attrs: {
        "disabled": _vm.disabledInputs() || _vm.loadingVariationAttributes
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.localVarAttrs, attribute.id, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": ""
      },
      domProps: {
        "value": null
      }
    }, [_vm._v(_vm._s(_vm.getVariationAttributePlaceholder(attribute)))]), _vm._v(" "), _vm._l((attribute.values), function(val) {
      return _c('option', {
        key: val.id,
        domProps: {
          "value": {
            id: val.id,
            name: val.name
          }
        }
      }, [_vm._v("\n          " + _vm._s(val.name) + "\n        ")])
    })], 2) : _c('input', {
      key: 'tx-' + attribute.id + '-' + (_vm.variation.sku || _vm.variation.id || ''),
      staticClass: "form-input",
      attrs: {
        "type": "text",
        "placeholder": _vm.getVariationAttributePlaceholder(attribute),
        "disabled": _vm.disabledInputs() || _vm.loadingVariationAttributes
      },
      domProps: {
        "value": (_vm.localVarAttrs[attribute.id] && _vm.localVarAttrs[attribute.id].name) || ''
      },
      on: {
        "input": function (e) { return _vm.$set(_vm.localVarAttrs, attribute.id, e.target.value ? {
          id: null,
          name: e.target.value
        } : null); }
      }
    })], 1)
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19976456","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/shein/provide/Variation.vue
// module id = 2948
// module chunks = 0